import { type WorkOrderCreationPayload } from 'types/Squares/WorkOrderManagement/work.order.creation.form.types';
import BaseAPI from '../../base.api';
import {
  type BulkUpdateWorkOrderPayload,
  type ExportWorkOrderPayload,
  type ImportWorkOrderPayload,
  type WorkOrder,
  type WorkOrderDeletePayload,
} from 'types/Squares/WorkOrderManagement/work.order.management.types';

export default class SquaresAPI extends BaseAPI {
  /**
   * Gets all operators the current user has access to
   * @returns A list of operators
   */

  getAllWorkOrders = async () => {
    const response = await this.API.get(`work-orders`);
    return response.data;
  };

  createWorkOrder = async (payload: WorkOrderCreationPayload) => {
    const response = await this.API.post(`work-orders`, payload);
    return response.data;
  };

  updateWorkOrder = async (
    workOrderId: string,
    payload: Partial<WorkOrder>
  ) => {
    const formattedPayload = {
      [workOrderId]: payload,
    };

    const response = await this.API.patch(`work-orders/`, formattedPayload);
    return response.data;
  };

  deleteWorkOrder = async (payload: WorkOrderDeletePayload) => {
    const formattedPayload = {
      [payload.workOrderId]: [...payload.components],
    };

    const response = await this.API.delete('work-orders/', {
      data: formattedPayload,
    });

    return response.data;
  };

  bulkDeleteWorkOrder = async (payload: string[]) => {
    const response = await this.API.delete(`work-orders/bulk`, {
      data: payload,
    });
    return response.data;
  };

  bulkUpdateWorkOrder = async (payload: BulkUpdateWorkOrderPayload) => {
    const response = await this.API.patch(`work-orders/bulk`, payload);
    return response.data;
  };

  exportWorkOrder = async (payload: ExportWorkOrderPayload) => {
    const response = await this.API.post(`work-orders/export`, payload, {
      responseType: 'arraybuffer',
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      params: {
        workflowType: payload.workflowType,
      },
    });
    return response.data;
  };

  importWorkOrder = async (payload: ImportWorkOrderPayload) => {
    const formData = new FormData();
    formData.append('file', payload.file);
    const response = await this.API.post(`work-orders/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: {
        workflowType: payload.workflowType,
      },
    });

    return response.data;
  };
}
